Alpine.data("customBox", () => ({
  activeBox: null,
  boxMax: 0,
  boxProducts: [],
  availableSelections: [],
  userSelections: [],
  isPanelActive: false,
  isReady: false,
  isInnerSliderReady: false,
  isTrayOpen: false,
  activeModalIndex: 0,
  slider: null,
  innerSlider: null,
  isQuickviewActive: false,
  isQuickSliderReady: false,
  isQuickNavReady: false,
  activeQuickProduct: {},
  yotpoAPI: null,
  isToastActive: false,
  activeSelectionIndex: null,
  toastText: "out of stock :(",
  addingToCart: false,
  addedToCart: false,
  userSelectionsComplete: false,
  innerTimeout: null,
  quantity: 1,
  reviewsItem: null,
  activeFilters: [],
  activeFilterMenu: null,
  mobileFilterOpen: false,
  dataInterval: null,
  yotpoInterval: null,
  chooseButtonClicked: false,
  comingBack: false,
  modalInfo:{},
  imgURL,
  toUSD(amount) {
    return Shopify.formatMoney(amount, $('body').data('money-format'))
  },
  formatTitle(title) {return title.includes(' - ') ? title.split(' - ')[0].trim() : title.split('-')[0].trim()},
  formatFill(tags) {
    const fillTag = tags.find(tag => tag.startsWith('fill:'))
    if (fillTag) {
      return ` - ${fillTag.replace('fill:', '')}`
    }
    return ''
  },
  formatProductType(title) {return title.includes(' - ') ? title.split(' - ').slice(-1)[0].trim() : title.split('-').slice(-1)[0].trim()},
  shorten(text){text.split('<br>')[0]},
  get filters() {
    let _filters = {
      fragrance: [],
      "container-color": [],
      "scent-family": [],
    };

    this.availableSelections.forEach((item) => {
      for (const name in _filters) {
        item.product.tags
          .filter((tag) => tag.startsWith(`${name}:`))
          .forEach((tag) => {
            if (!_filters[name].includes(tag)) {
              _filters[name].push(tag);
            }
          });
      }
    });

    for (const name in _filters) {
      _filters[name].sort();
    }

    return _filters;
  },
  get filtersModal() {
    let _filters = {
      fragrance: [],
      "container-color": [],
      "scent-family": [],
    };

    this.availableSelections.forEach((item) => {
      for (const name in _filters) {
        item.product.tags
          .filter((tag) => tag.startsWith(`${name}:`))
          .forEach((tag) => {
            if (!_filters[name].includes(tag)) {
              _filters[name].push(tag);
            }
          });
      }
    });

    for (const name in _filters) {
      _filters[name].sort();
    }

    return _filters;
  },
  get filteredSelections() {
    const filterGroups = ["fragrance", "container-color", "scent-family"];
    let filtered = this.availableSelections;

    filterGroups.forEach((name) => {
      const activeGroupFilters = this.activeFilters.filter((item) =>
        item.startsWith(name)
      );
      if (activeGroupFilters.length > 0) {
        filtered = filtered.filter(
          (item) =>
            item.product.tags.filter((value) =>
              activeGroupFilters.includes(value)
            ).length > 0
        );
      }
    });

    return filtered;
  },
  get stepTwoActive() {
    return (
      this.slider &&
      (this.slider.selectedIndex === 1 || this.slider.selectedIndex === 2)
    );
  },
  get stepThreeActive() {
    return this.slider && this.slider.selectedIndex === 2;
  },
  get activeModalInfo() {
    return this.boxProducts[this.activeModalIndex];
  },
  async init() {
    this.loadBoxProducts();
    // Document ready
    $(() => {
      // this.scrollToTop()
      this.buildFlickity();
      this.loadYotpo();
    })
    // this.buildFlickity();
    //alert('loaded')
  },
  loadYotpo() {
    this.yotpoInterval = setInterval(() => {
      if (typeof Yotpo !== 'undefined' && typeof yotpo !== 'undefined') {
        this.isReady = true
        this.slider.reloadCells()
        this.yotpoAPI = Yotpo ? new Yotpo.API(yotpo) : null
        clearInterval(this.yotpoInterval)
      }
    }, 2000)
  },
  openToast(text) {
    let _to = null;
    this.isToastActive = true;
    this.toastText = text;
    clearTimeout(_to);
    _to = setTimeout(() => {
      this.isToastActive = false;
    }, 10000);
  },
  closeToast() {
    this.isToastActive = false;
  },
  loadBoxProducts() {
    // load products when BoxProducts and BoxMetaData are available
    this.dataInterval = setInterval(() => {
      if (window.BoxProducts && window.BoxMetaData) {
        this.boxProducts = window.BoxProducts.filter((box) => {
          if (box.error) return false;
          return true;
        }).map((box) => {
          const meta = window.BoxMetaData.find((x) => x.id === box.id);
          return { ...box, ...meta };
        });
        clearInterval(this.dataInterval);
      }
    }, 100);
  },
  // SLiders
  buildInnerFlickity() {
    const selectionsWrap = document.querySelector('[data-selections-wrap]')
    if (this.innerSlider) {
      this.innerSlider.destroy()
    }
    this.innerSlider = new Flickity(selectionsWrap, {
      prevNextButtons: true,
      pageDots: false,
      draggable: true,
      imagesLoaded: true,
      initialIndex: 1,
      cellAlign: 'center',
      freeScroll: false,
      contain: this.boxMax <= 3 && window.innerWidth >= 1024,
      on: {
        ready: () => {
          this.slider.reloadCells()
          if(!this.isInnerSliderReady) {
            this.refreshSliders()
            this.isInnerSliderReady = true
          }
        }
      }
    })
    this.innerSlider.on('dragStart', () => {
      this.innerSlider.slider.childNodes.forEach((slide) => { slide.querySelector('.box-builder__selection-btn').style.pointerEvents = 'none' })
    })
    this.innerSlider.on('dragEnd', () => {
      this.innerSlider.slider.childNodes.forEach((slide) => { slide.querySelector('.box-builder__selection-btn').style.pointerEvents = 'all' })
    })
  },
  buildFlickity() {
    const slides = document.querySelector('[data-box-builder-steps]')
    if (slides) {
      if (this.slider) {
        this.slider.destroy()
      }
      this.slider = new Flickity(slides, {
        prevNextButtons: false,
        pageDots: false,
        draggable: false,
        imagesLoaded: true,
        adaptiveHeight: true
      })

      this.slider.on('change', i => {
        this.slider.reloadCells()
        this.scrollToTop()
        let searchParams = new URLSearchParams(window.location.search)

        switch (i) {
        case 0:
          this.userSelections = []
          clearTimeout(this.innerTimeout)
          this.isInnerSliderReady = false
          this.userSelectionsComplete = false
          if (this.innerSlider) {
            this.innerSlider.destroy()
          }

          // If the slider is returned to step one remove selected querystring parameters since user is starting over
          searchParams.delete('box')
          searchParams.delete('skus')
          if (Array.from(searchParams).length === 0) {
            let href = window.location.href
            let url = href.split('?')
            window.history.pushState(null, null, url[0])
          } else {
            let pageUrl = '?' + searchParams.toString().replaceAll('%2C', ',')
            window.history.pushState('', '', pageUrl)
          }

          break
        case 1:
          this.isInnerSliderReady = false
          break
        }
      })

      this.slider.on('settle', i => {
        this.slider.reloadCells()
        switch (i) {
        case 0:
          break
        case 1:
          clearTimeout(this.innerTimeout)
          this.innerTimeout = setTimeout(() => {
            this.buildInnerFlickity()
          }, 800)
          break
        }
      })
    }
  },
  loadSlide(i) {
    if (this.slider) {
      this.slider.select(i)
    }
  },
  loadReviewStep() {
    this.slider.select(2)
  },
  handleResize() {
    // prevent ios scroll from firing resize event
    let windowWidth = window.innerWidth
    window.addEventListener('resize', () => {
      if (window.innerWidth !== windowWidth) {
        this.buildFlickity()
        this.buildInnerFlickity()
      }
    })
  },
  scrollToTop() {
    let top = 0
    if ($('.collection__header').length) {
      top = $('.collection__header').outerHeight()
    }
    $('html, body').animate({ scrollTop: top }, 'slow')
  },
  closeQuickview() {
    this.isQuickviewActive = false
    this.isQuickSliderReady = false
    this.isQuickNavReady = false
    this.activeQuickProduct = {}
    // clearAllBodyScrollLocks()
    bodyScrollLock.clearAllBodyScrollLocks()
  },
  handleKeyboardClose() {
    window.addEventListener('keyup', (e) => {
      if (e.key === 'Escape') {
        if (this.isQuickviewActive) {
          this.closeQuickview()
        } else {
          this.closeTray()
          this.isTrayOpen = false
          this.isPanelActive = false
        }
      }
    })
  },
  handleMobileClick(product) {
    if (window.innerWidth <= 1024) {
      this.addSelection(product)
    }
  },
  refreshSliders() {
    setTimeout(() => {
      this.innerSlider.reloadCells()
      this.slider.reloadCells()
      const nextSlot = this.userSelections.findIndex((x) => x.isEmpty)
      if(nextSlot != -1 && !this.comingBack) {
        this.innerSlider.select(nextSlot + 1)
      }
      else if (this.comingBack) {
        this.innerSlider.select(1)
        this.comingBack = false
      }
    }, 300)
  },
  addSelection(product) {
    if (this.userSelectionsComplete) {
      this.openToast('Maximum items added.')
      this.closeQuickview()
      this.scrollToTop()
      return
    }

    if (this.activeSelectionIndex != null) {
      // this.$set(this.userSelections[this.activeSelectionIndex], 'isEmpty', false)
      this.userSelections[this.activeSelectionIndex].isEmpty = false
      let newShit = { ...this.userSelections[this.activeSelectionIndex], ...product }
      this.userSelections[this.activeSelectionIndex] = newShit
      this.refreshSliders()
      this.closeTray()
      this.closeQuickview()
      this.activeSelectionIndex = null
    } else {
      const slot = this.userSelections.findIndex((x) => x.isEmpty)
      this.userSelections[slot].isEmpty = false
      let newShit = { ...this.userSelections[slot], ...product }
      this.userSelections[slot] = newShit
      // this.$forceUpdate()
      this.refreshSliders()
      this.closeQuickview()
      this.activeSelectionIndex = null
    }

    // When a selection is added update the querystring parameters to include the new sku
    this.updateQueryParamSkus()

    this.scrollToTop()
    this.checkComplete()
  },
  // Update the query string to have the skus of all the selected products in the bundle
  updateQueryParamSkus() {
    let searchParams = new URLSearchParams(window.location.search)

    let skusList = []
    for (let selectionIndex = 0; selectionIndex < this.userSelections.length; ++selectionIndex) {
      if (!this.userSelections[selectionIndex].isEmpty) {
        skusList.push(this.userSelections[selectionIndex].product.variants[0].sku)
      }
    }

    let skusString = skusList.join(',')

    // If no skus are present in the query string remove the sku parameter entirely from the query string
    if (skusList.length > 0) {
      searchParams.set('skus', skusString)
    } else {
      searchParams.delete('skus')
    }
    let pageUrl = '?' + searchParams.toString().replaceAll('%2C', ',')
    window.history.pushState('', '', pageUrl)
  },
  checkComplete() {
    this.userSelectionsComplete = this.userSelections.every((x) => !x.isEmpty)
  },
  removeSelection(index) {
    this.userSelections[index] = {isEmpty: true}
    setTimeout(() => {
    this.checkComplete()
    this.slider.reloadCells()

    // Update the query string to remove the sku of the removed product from the bundle
    this.updateQueryParamSkus()
     },0)
  },
  goBack() {
    if (this.slider) {
      this.slider.previous()
      this.comingBack = true
    }
  },
  isNew(item) {
    const newTag = item.tags.find(tag => tag.toLowerCase() === 'new')
    if (newTag) {
      return true
    }
    return false
  },
  handleBoxProdClick(box, boxMax, boxCollection) {
    this.activeBox = box
    this.reviewsItem = box
    this.setBoxMax(boxMax)
    this.getCollection(boxCollection)

    let searchParams = new URLSearchParams(window.location.search)
    searchParams.set('box', box.handle)
    let pageUrl = '?' + searchParams.toString().replaceAll('%2C', ',')
    window.history.pushState('', '', pageUrl)
  },
  setBoxMax(n) {
    this.userSelections = []
    this.addedToCart = false
    this.slider.select(1)
    this.boxMax = parseInt(n)
    for (let i = 0; i <= n - 1; i++) {
      this.userSelections.push({
        'isEmpty': true
      })
    }
  },
  getCollection(collection) {
    this.availableSelections = []
    fetch(`/collections/${collection}?view=box-builder.json`)
      .then(res => res.json())
      .then(response => {
        if (response.products.length) {
          this.availableSelections = response.products
        } else {
          this.availableSelections = []
        }
      })
      .catch(error => {
        // console.log(error)
      })
  },
  handleBoxProdClick(box, boxMax, boxCollection) {
    this.activeBox = box
    this.reviewsItem = box
    this.setBoxMax(boxMax)
    this.getCollection(boxCollection)

    let searchParams = new URLSearchParams(window.location.search)
    searchParams.set('box', box.handle)
    let pageUrl = '?' + searchParams.toString().replaceAll('%2C', ',')
    window.history.pushState('', '', pageUrl)
  },
  setReviewsItem(item) {
    this.reviewsItem = item
    this.scrollToReviews()
  },
  openModal(i,item,box,collection) {
    this.activeModalIndex = i
    this.isPanelActive = true
    this.modalInfo={item:item, box:box, collection:collection}
  },
  closeModalAndStart(){
   this.handleBoxProdClick(this.modalInfo.item, this.modalInfo.box , this.modalInfo.collection);
   this.modalInfo={}
   this.closeModal()
  },
  closeModal() {
    this.isPanelActive = false
    this.isTrayOpen = false
    this.closeTray()
    // clearAllBodyScrollLocks()
    bodyScrollLock.clearAllBodyScrollLocks()
  },
  scrollToReviews() {
    const reviewsContainer = $('[data-box-reviews]')
    const headerInner = $('.main-nav__wrapper')
    if (reviewsContainer.length) {
      const top = reviewsContainer.offset().top - headerInner.outerHeight()
      $('html, body').animate({ scrollTop: top }, 'slow')
    }
  },
  handleTrayOpen(index) {
    if (!this.userSelections[index].isEmpty) {
      return
    }
    this.isTrayOpen = true
    this.activeSelectionIndex = index
    const state = Flip.getState('.box-builder__tray-static')
    document.querySelector('.box-builder__tray-static').classList.add('fixed')
    Flip.from(state, {
      duration: 0.3,
      width: '100%',
      absolute: true
    })
    const tray = document.querySelector('.box-builder__tray-static')
    tray.scrollTop = 0
    // disableBodyScroll(tray)
    bodyScrollLock.disableBodyScroll(tray)
  },
  openTray(index) {
    if (!this.userSelections[index].isEmpty) {
      return
    }
    const tray = document.querySelector('.box-builder__tray-static')
    tray.scrollTop = 0
    this.isTrayOpen = true
    this.activeSelectionIndex = index
    // disableBodyScroll(tray)
    bodyScrollLock.disableBodyScroll(tray)
  },
  closeTray() {
    this.isTrayOpen = false
    const state = Flip.getState('.box-builder__tray-static')
    document.querySelector('.box-builder__tray-static').classList.remove('fixed')
    Flip.from(state, {
      duration: 0.3,
      width: '100%'
    })
    // clearAllBodyScrollLocks()
    bodyScrollLock.clearAllBodyScrollLocks()
  },
  uniqueCode(length = 5) {
    let code = ''
    while (code.length < length) {
      code += Math.floor(Math.random() * 1000).toString(36)
    }
    return code.substr(0, length)
  },
  async addToCart() {
    this.addingToCart = true
    const code = this.uniqueCode()
    const itemSkus = this.userSelections.map(item => item.product.variants[0].sku)

    let itemIds = []
    let didFail = false

    // Pluck out the variant id's
    for (const item of this.userSelections) {
      itemIds.push(item.product.variants[0].id)
    }

    // Quantity is expressed as N separate gift sets, not as N of each component.
    //
    // The cart transform merges a build's lines into one group line. Handing it
    // quantity 3 on every component produced a single gift set containing 3 of
    // everything: the cart showed "Qty: 1" at 3x the price, and checkout listed
    // "3 x Baltic Amber" inside one bundle.
    //
    // Building the box N times instead, each with its own _bundle code and a
    // quantity of 1, gives N gift sets that each show and price correctly and
    // can be removed on their own. They all go in a single /cart/add.js call.
    const boxCount = Math.max(1, parseInt(this.quantity, 10) || 1)

    // uniqueCode() is only 5 random characters, so insist on distinct codes here:
    // two boxes sharing one would be merged back into a single gift set.
    const usedCodes = new Set([code])
    const nextBoxCode = () => {
      let next = this.uniqueCode()
      while (usedCodes.has(next)) next = this.uniqueCode()
      usedCodes.add(next)
      return next
    }

    let itemsToAdd = []
    for (let box = 0; box < boxCount; box++) {
      const boxCode = box === 0 ? code : nextBoxCode()

      // loop over variant id's in reverse to keep the customer's desired order
      // because items added first are lower in the order
      for (let i = (itemIds.length - 1); i >= 0; i--) {
        itemsToAdd.push({
          quantity: 1,
          id: itemIds[i],
          properties: {
            _bundle: boxCode,
            _id: this.uniqueCode()
          }
        })
      }

      // adding bundle parent on top
      itemsToAdd.push({
        quantity: 1,
        id: this.activeBox.variants[0].id,
        properties: {
          _bundle: boxCode,
          _bundle_skus: itemSkus.join(',')
        }
      })
    }

    await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: itemsToAdd
      })
    }).then(res => res.json())
    .then(data => console.log(data))
    .catch(async e => {
      let { description } = error.response.data
      alert(description)
      didFail = true
      let updates = {}
      for (let j = (itemIds.length - 1); j > i; --j) {
        updates[itemIds[j]] = 0
      }
      if (updates) {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ updates: updates })
        }).then(res => res.json())
        .then(removeResponse => console.log('Update Response', removeResponse))

        // VueMinicart.$store.dispatch('refreshCart')
        this.refreshCart()
      }
      this.addingToCart = false

      return
    })

    this.addingToCart = false
    this.addedToCart = true
    // VueMinicart.$store.dispatch('refreshCart')
    this.refreshCart()
    // open the mini-cart
    // document.querySelector('.icon-bag.mini_cart').click()

    setTimeout(() => {
      this.addedToCart = false
    }, 500)
  },
  refreshCart: function () {
    $.ajax({
      url: '/cart.json',
      dataType: 'json',
      cache: false,
      type: 'get',
      success(data) {
        window.refreshCart(data);
        document.documentElement.classList.add("cart-active");
      },
    });
  },
  handleQtyInput: function(event) {
    let value = Number(event.target.value)
    if (value >= 100) {
      this.quantity = 100
    } else {
      this.quantity = value
    }
  },
  changeQuantity(val) {
    if (this.quantity >= 100) {
      // limit to 100 at a time
      return
    } else {
      this.quantity += val
    }

    if (this.quantity === 0) this.quantity = 1
  },
  // Filtering
  clearFilters() {
    this.activeFilterMenu = null
    this.activeFilters = []
  },
  filterGroupCount(name) {
    const activeFilterCount = this.activeFilters.filter(item => item.startsWith(`${name}:`))
    if (activeFilterCount.length) {
      return `(${activeFilterCount.length})`
    }
    return ''
  },
  filterGroupTitle(name) {
    return name.split('-').join(' ')
  },
  optionImage(option) {
    let optionImageUrl = option
      .toLowerCase()
      .replace(/ /g, '-')
      .replace('container-color:', 'container_color-')
    return optionImageUrl + '.png'
  },
  optionTitle(name, option) {
    return option.replace(`${name}:`, '').split('-').join(' ')
  },
  toggleFilter(option) {
    let newFilters = this.activeFilters

    if (!this.activeFilters.includes(option)) {
      newFilters.push(option)
    } else {
      newFilters = newFilters.filter(item => item !== option)
    }

    this.activeFilters = newFilters
  },
  toggleFilterMenu(name) {
    if (this.activeFilterMenu === name) {
      this.activeFilterMenu = null
    } else {
      this.activeFilterMenu = name
    }
  },
  toggleMobileFilterMenu(name) {
    if (this.mobileFilterOpen) {
      this.mobileFilterOpen = false
    } else {
      this.mobileFilterOpen = true
    }
  }
}));


// utilities
function imgURL(src, size, center = false) {
	if (src === undefined || src === 'undefined') return
	// Remove any current image size then add the new image size
	let count = (src.match(/\.jpg|\.png|\.gif|\.jpeg/g) || []).length
	let centerVal = ''

	if (center) {
		centerVal = '_crop_center'
	}
	if (src === null) {
		return
	}
	if (count > 1) {
		return src
	}

	return src
		.replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|1024x1024|2048x2048|master)+\./g, '.')
		.replace(/\.jpg|\.png|\.gif|\.jpeg/g, match => {
			return '_' + size + centerVal + match
		})
}
